module.exports = __webpack_public_path__ + "static/img/02.30a9b0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/05/02.jpg
// module id = 49Nx
// module chunks = 0